import React from "react";
import { faFlag } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { updatePlanRoom } from "../../store/actions/gc_qualify/gcQualify.actions";
import { useFeatureAccess } from "../../hooks/useFeatureAccess";

const ReportProblemContainer = ({
  row,
  handleSetLoginModal,
  handleSetPaymentModal,
  handleSetFreeMode,
  price_id,
  free_mode_count,
  user,
}) => {
  const { hasFeatureAccess, enforceAccess } = useFeatureAccess("Planroom");
  const dispatch = useDispatch();

  const handleFlagClick = (e) => {
    if (!user) {
      handleSetLoginModal();
    } else if (!hasFeatureAccess) {
      enforceAccess();
    } else {
      handleSetFreeMode();
      dispatch(updatePlanRoom({ flag: true, company_account_name: row.name }));
    }
  };
  return (
    <div className="text-center cursor-pointer">
      <FontAwesomeIcon
        icon={faFlag}
        size="lg"
        style={{ color: "red" }}
        onClick={handleFlagClick}
      />
    </div>
  );
};

export default ReportProblemContainer;
